export const es = {
    title: `Panel`,
    welcome: `¡Bienvenido de nuevo, {name}!`,
};
//# sourceMappingURL=es.js.map